// extracted by mini-css-extract-plugin
export default {"container":"ResourceCard_container__f6bht","left":"ResourceCard_left__-afK2","fileIcon":"ResourceCard_fileIcon__FrvdT","fileType":"ResourceCard_fileType__bXjPw"};